import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { Driver } from "../../drivers.types";
import { requestDriverPriority } from "./driverPriority.request";

const useDriverPriority = (
  options?: MutationOptions<Driver[], ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestDriverPriority,
    ...options
  });
};

export default useDriverPriority;
